// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".loyalty-progress--top-nav-mobile[data-v-268cc42e] {\n  background-color: #f2f5f5;\n}\n\n.text--top-nav[data-v-268cc42e] {\n  font-weight: var(--magic-font-weight-semibold, 600);\n  color: var(--magic-text-dark, #231f20);\n}\n.text--top-nav-small[data-v-268cc42e] {\n  font-weight: var(--magic-font-weight-semibold, 600);\n  color: var(--magic-text-dark, #231f20);\n}", ""]);
// Exports
module.exports = exports;
